<svg width="86" height="59" viewBox="0 0 86 59" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="7.95124" y="2.06061" width="70.0943" height="45.5319" rx="4.39424" stroke="#87929D" stroke-width="4.12122"/>
<path d="M28.8711 32.0195L57.3394 16.7079" stroke="#87929D" stroke-width="3" stroke-linecap="round"/>
<g clip-path="url(#clip0_3430_7602)">
<path d="M57.4595 21.7876L59.2582 15.8183L53.2891 14.0195" stroke="#87929D" stroke-width="2.08795" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<g clip-path="url(#clip1_3430_7602)">
<path d="M28.5248 27.1616L27.1548 33.255L33.248 34.625" stroke="#87929D" stroke-width="2.09165" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<path d="M3 56.3555H83" stroke="#87929D" stroke-width="4.12122" stroke-linecap="round"/>
<defs>
<clipPath id="clip0_3430_7602">
<rect width="11.1368" height="11.1369" fill="white" transform="matrix(0.88105 -0.473022 0.47301 0.881057 50.2832 14.2109)"/>
</clipPath>
<clipPath id="clip1_3430_7602">
<rect width="11.1566" height="11.1567" fill="white" transform="matrix(-0.844992 0.534779 -0.534767 -0.845 36.2324 34.2266)"/>
</clipPath>
</defs>
</svg>
